/**
 * Redux Store Configuration
 * Configures Redux Toolkit store with health slice
 */

import { configureStore } from '@reduxjs/toolkit';
import healthReducer from './healthSlice';
import dashboardReducer from './dashboardSlice';
import facilitiesReducer from './facilitiesSlice';

export const store = configureStore({
  reducer: {
    health: healthReducer,
    dashboard: dashboardReducer,
    facilities: facilitiesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for non-serializable values
        ignoredActions: ['persist/PERSIST'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;